import { IndividualLight } from "@/Common/Api/Individuals/Dto/IndividualLight";
import { Guid } from "@/Common/Models/Guid";
import { PrescriptionRenewalItemResponse } from "../Api/Dto/PrescriptionRenewalItemResponse";
import { PrescriptionRenewalStatus } from "../Common/PrescriptionRenewalStatus";

class PrescriptionRenewal {
    public id: Guid;
    public prescriptionId: Guid;
    public documentId: Guid;
    public status: PrescriptionRenewalStatus;
    public documentDate: Date;
    public attachOnDate: Date;
    public isUrgent: boolean;
    public source: string;
    public siteId: Guid;
    public providerContactId: Guid;
    public patientContactId: Guid;
    public patientFirstName: string;
    public patientLastName: string;
    public patientPreferredName: string;
    public providers: IndividualLight[];

    public static fromResponseModel(prescriptionRenewalResponse: PrescriptionRenewalItemResponse): PrescriptionRenewal {
        if (!prescriptionRenewalResponse)
            return null;

        return {
            id: prescriptionRenewalResponse.Id,
            prescriptionId: prescriptionRenewalResponse.PrescriptionId,
            documentId: prescriptionRenewalResponse.DocumentId,
            status: prescriptionRenewalResponse.Status,
            documentDate: prescriptionRenewalResponse.DocumentDate,
            attachOnDate: prescriptionRenewalResponse.AttachOnDate,
            isUrgent: prescriptionRenewalResponse.IsUrgent,
            source: prescriptionRenewalResponse.Source,
            siteId: prescriptionRenewalResponse.SiteId,
            providerContactId: prescriptionRenewalResponse.ProviderContactId,
            patientContactId: prescriptionRenewalResponse.PatientContactId,
            patientFirstName: prescriptionRenewalResponse.PatientFirstName,
            patientLastName: prescriptionRenewalResponse.PatientLastName,
            patientPreferredName: prescriptionRenewalResponse.PatientPreferredName,
            providers: prescriptionRenewalResponse.Providers
        };
    }

    public static isPrescriptionRenewalCompleted(prescriptionRenewalStatus: PrescriptionRenewalStatus): boolean {
        return prescriptionRenewalStatus === PrescriptionRenewalStatus.Completed;
    }
}

export { PrescriptionRenewal };
